import { GenericFormItem } from 'skyone-lib/lib/GenericForm/interfaces';

export const customFields: GenericFormItem[] = [
  {
    gridXs: 5,
    label: 'PARTNER_PAGE.SUBDOMAIN_KEY',
    stateKey: 'domain',
    validateOnChange: true,
  },
  {
    gridXs: 5,
    label: 'PARTNER_PAGE.TITLE_KEY',
    validateOnChange: true,
    stateKey: 'title',
  },
  {
    gridXs: 3,
    label: 'PARTNER_PAGE.TEXT_PRINCIPAL_COLOR',
    validateOnChange: true,
    stateKey: 'primary.main',
  },
  {
    gridXs: 3,
    label: 'PARTNER_PAGE.TEXT_PRINCIPAL_COLOR',
    validateOnChange: true,
    stateKey: 'primary_contrast_text',
  },
  {
    gridXs: 3,
    label: 'PARTNER_PAGE.TEXT_PRINCIPAL_COLOR',
    validateOnChange: true,
    stateKey: 'primary.dark',
  },
  {
    gridXs: 3,
    label: 'PARTNER_PAGE.TEXT_PRINCIPAL_COLOR',
    validateOnChange: true,
    stateKey: 'primary.light',
  },
  {
    gridXs: 3,
    label: 'PARTNER_PAGE.TEXT_PRINCIPAL_COLOR',
    validateOnChange: true,
    stateKey: 'secondary.main',
  },
  {
    gridXs: 3,
    label: 'PARTNER_PAGE.TEXT_PRINCIPAL_COLOR',
    validateOnChange: true,
    stateKey: 'secondary_contrast_text',
  },
  {
    gridXs: 3,
    label: 'PARTNER_PAGE.TEXT_PRINCIPAL_COLOR',
    validateOnChange: true,
    stateKey: 'secondary.dark',
  },
  {
    gridXs: 3,
    label: 'PARTNER_PAGE.TEXT_PRINCIPAL_COLOR',
    validateOnChange: true,
    stateKey: 'secondary.light',
  },
  {
    gridXs: 3,
    label: 'PARTNER_PAGE.TEXT_PRINCIPAL_COLOR',
    validateOnChange: true,
    stateKey: 'primary_color',
  },
  {
    gridXs: 3,
    label: 'PARTNER_PAGE.PRIMARY_COLOR_KEY',
    validateOnChange: true,
    stateKey: 'secondary_color',
  },
  {
    gridXs: 3,
    label: 'PARTNER_PAGE.LOGIN_BUTTONS_COLORS_KEY',
    validateOnChange: true,
    stateKey: 'background_color',
  },
  {
    gridXs: 3,
    label: 'PARTNER_PAGE.MSG_COLORS_KEY',
    validateOnChange: true,
    stateKey: 'message_text_color',
  },
  {
    gridXs: 3,
    label: 'PARTNER_PAGE.COLOR_HOVER_TEXT_KEY',
    validateOnChange: true,
    stateKey: 'text_hover_color',
  },
  {
    gridXs: 5,
    label: 'PARTNER_PAGE.LOGIN_FONT_SIZE_KEY',
    isSelect: true,
    options: [
      { value: '0px', label: 'PARTNER_PAGE.NO_TEXT_KEY' },
      { value: '20px', label: '20px' },
      { value: '30px', label: '30px' },
      { value: '45px', label: '45px' },
      { value: '50px', label: '50px' },
    ],
    validateOnChange: true,
    stateKey: 'header_login_font_size',
  },
  {
    gridXs: 5,
    label: 'PARTNER_PAGE.DESCRIPTION_FONT_SIZE_KEY',
    isSelect: true,
    options: [
      { value: '0px', label: 'PARTNER_PAGE.NO_TEXT_KEY' },
      { value: '10px', label: '10px' },
      { value: '12px', label: '12px' },
      { value: '14px', label: '14px' },
      { value: '16px', label: '16px' },
      { value: '18px', label: '18px' },
      { value: '20px', label: '20px' },
    ],
    validateOnChange: true,
    stateKey: 'description_login_font_size',
  },
  {
    gridXs: 5,
    label: 'LOGIN_PAGE_TITLE_TEXT_PTBR_KEY',
    stateKey: 'header_login_text_pt_br',
    validateOnChange: true,
    isMultiline: true,
  },
  {
    gridXs: 5,
    label: 'LOGIN_PAGE_SUBTITLE_TEXT_PTBR_KEY',
    stateKey: 'description_login_text_pt_br',
    validateOnChange: true,
    isMultiline: true,
  },
  {
    gridXs: 5,
    label: 'LOGIN_PAGE_TITLE_TEXT_EN_KEY',
    stateKey: 'header_login_text_en',
    validateOnChange: true,
    isMultiline: true,
  },
  {
    gridXs: 5,
    label: 'LOGIN_PAGE_SUBTITLE_TEXT_EN_KEY',
    stateKey: 'description_login_text_en',
    validateOnChange: true,
    isMultiline: true,
  },
  {
    gridXs: 5,
    label: 'LOGIN_PAGE_TITLE_TEXT_ES_KEY',
    stateKey: 'header_login_text_es',
    validateOnChange: true,
    isMultiline: true,
  },
  {
    gridXs: 5,
    label: 'LOGIN_PAGE_SUBTITLE_TEXT_ES_KEY',
    stateKey: 'description_login_text_es',
    validateOnChange: true,
    isMultiline: true,
  },
  {
    gridXs: 5,
    label: 'MFA_FONT_SIZE_KEY',
    isSelect: true,
    options: [
      { value: '0px', label: 'PARTNER_PAGE.NO_TEXT_KEY' },
      { value: '20px', label: '20px' },
      { value: '30px', label: '30px' },
      { value: '45px', label: '45px' },
      { value: '50px', label: '50px' },
    ],
    validateOnChange: true,
    stateKey: 'header_mfa_font_size',
  },
  {
    gridXs: 5,
    label: 'DESCRIPTION_MFA_FONT_SIZE_KEY',
    isSelect: true,
    options: [
      { value: '0px', label: 'PARTNER_PAGE.NO_TEXT_KEY' },
      { value: '10px', label: '10px' },
      { value: '12px', label: '12px' },
      { value: '14px', label: '14px' },
      { value: '16px', label: '16px' },
      { value: '18px', label: '18px' },
      { value: '20px', label: '20px' },
    ],
    validateOnChange: true,
    stateKey: 'description_mfa_font_size',
  },
  {
    gridXs: 5,
    label: 'MFA_PAGE_TITLE_TEXT_PTBR_KEY',
    stateKey: 'header_mfa_text_pt_br',
    validateOnChange: true,
    isMultiline: true,
  },
  {
    gridXs: 5,
    label: 'MFA_PAGE_SUBTITLE_TEXT_PTBR_KEY',
    stateKey: 'description_mfa_text_pt_br',
    validateOnChange: true,
    isMultiline: true,
  },
  {
    gridXs: 5,
    label: 'MFA_PAGE_TITLE_TEXT_EN_KEY',
    stateKey: 'header_mfa_text_en',
    validateOnChange: true,
    isMultiline: true,
  },
  {
    gridXs: 5,
    label: 'MFA_PAGE_SUBTITLE_TEXT_EN_KEY',
    stateKey: 'description_mfa_text_en',
    validateOnChange: true,
    isMultiline: true,
  },
  {
    gridXs: 5,
    label: 'MFA_PAGE_TITLE_TEXT_ES_KEY',
    stateKey: 'header_mfa_text_es',
    validateOnChange: true,
    isMultiline: true,
  },
  {
    gridXs: 5,
    label: 'MFA_PAGE_SUBTITLE_TEXT_ES_KEY',
    stateKey: 'description_mfa_text_es',
    validateOnChange: true,
    isMultiline: true,
  },
];

export default customFields;
